import { Charts } from "./Classes/Charts";
import { ModuleType } from "./Classes/Enums/ModyleType";


/**
 * @author Louis Scheepers
 */

let boxChart1, boxChart2, boxChart3, boxChart4, boxChart5, boxChart6, boxChart7, boxChart8;
let boxChart1popup, boxChart2popup, boxChart3popup, boxChart4popup, boxChart5popup, boxChart6popup, boxChart7popup, boxChart8popup;
let annexChart1, annexChart2, annexChart3, annexChart4, annexChart5, annexChart6, annexChart7, annexChart8;


/**
 * Listens for the createChart events sent from livewire
 */
window.addEventListener('createChart', event => {
    let box = event.detail.box;
    let module = event.detail.module;
    let route = event.detail.route;
    window.createChart(box, module, route);
});

/**
 * Prepares the charts for creation
 * @param box
 * @param module
 * @param route
 * @param params
 *
 * Generates module route
 * On load creation from box-manager
 */
window.createChart = async function(box, module, route, params = undefined) {

    $('#loader' + box).show();
    $("#chart" + box).hide();
    let boxModule = document.getElementById(box + "Module");
    let companyId, fromYear, fromMonth, toYear, toMonth;
    let animation = true;
    if (params !== undefined) {
        companyId = params['id'];
        fromYear = params['fromYear'];
        fromMonth = params['fromMonth'];
        toYear = params['toYear'];
        toMonth = params['toMonth'];
        animation = false;
    } else {
        companyId = $("#" + box + "CompanyId").val();
        fromYear = $("#" + box + "FromYear").val();
        fromMonth = $("#" + box + "FromMonth").val();
        toYear = $("#" + box + "ToYear").val();
        toMonth = $("#" + box + "ToMonth").val();
    }

    let url = getChartUrl(module, route, companyId, fromYear, fromMonth, toYear, toMonth);

    $.ajax({
        url: url,
        method: "GET",
        success:function(response){
            console.log(response);
            let args = {
                'module': module,
                'id': box,
                'url': url,
                'data': response,
                'animation': animation,
            }
            if(validateData(box, args['data'])){
                showData(box);
                handleChartCreation(box, args, boxModule, module);
                window.registerPopupEvents();
            }else{
                showNoData(box);
                console.log("No Data found for the current chart / period");
            }
        }
    });

}


/**
 * Triggers the Charts class to create and render the chart
 *
 * There are 16 possible locations for each chart. This code is necessary to stop charts overwriting each other.
 * If you find a better way to handle this please let me know louis@cubezoo.joburg
 * @param id
 * @param args
 * @param boxModule
 * @param module
 */
function handleChartCreation(id, args, boxModule, module) {

    console.log('handleChartCreation: ' + id);

    switch (id) {

        case 'box1':
            if (boxChart1 !== undefined) {
                boxChart1.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
            }
            boxChart1 = Charts.create(args);

            break;
        case 'box2':
            if (boxChart2 !== undefined) {
                boxChart2.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
            }
            boxChart2 = Charts.create(args);

            break;
        case 'box3':
            if (boxChart3 !== undefined) {
                boxChart3.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
            }
            boxChart3 = Charts.create(args);

            break;
        case 'box4':
            if (boxChart4 !== undefined) {
                boxChart4.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
            }
            boxChart4 = Charts.create(args);

            break;
        case 'box5':
            if (boxChart5 !== undefined) {
                boxChart5.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
                boxChart5 = Charts.create(args);
            }
            boxChart5 = Charts.create(args);

            break;
        case 'box6':
            if (boxChart6 !== undefined) {
                boxChart6.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
            }
            boxChart6 = Charts.create(args);

            break;
        case 'box7':
            if (boxChart7 !== undefined) {
                boxChart7.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
            }
            boxChart7 = Charts.create(args);

            break;
        case 'box8':
            if (boxChart8 !== undefined) {
                boxChart8.destroy();
                boxModule.value = module;
                boxModule.dispatchEvent(new Event("input"));
            }
            boxChart8 = Charts.create(args);

            break;
        case 'box1popup':
            if (boxChart1popup !== undefined) {
                boxChart1popup.destroy();
                boxChart1popup = undefined;
            }
            boxChart1popup = Charts.create(args);
            break;
        case 'box2popup':
            if (boxChart2popup !== undefined) {
                boxChart2popup.destroy();
                boxChart2popup = undefined;
            }
            boxChart2popup = Charts.create(args);
            break;
        case 'box3popup':
            if (boxChart3popup !== undefined) {
                boxChart3popup.destroy();
                boxChart3popup = undefined;
            }
            boxChart3popup = Charts.create(args);
            break;
        case 'box4popup':
            if (boxChart4popup !== undefined) {
                boxChart4popup.destroy();
                boxChart4popup = undefined;
            }
            boxChart4popup = Charts.create(args);
            break;
        case 'box5popup':
            if (boxChart5popup !== undefined) {
                boxChart5popup.destroy();
                boxChart5popup = undefined;
            }
            boxChart5popup = Charts.create(args);
            break;
        case 'box6popup':
            if (boxChart6popup !== undefined) {
                boxChart6popup.destroy();
                boxChart6popup = undefined;
            }
            boxChart6popup = Charts.create(args);
            break;
        case 'box7popup':
            if (boxChart7popup !== undefined) {
                boxChart7popup.destroy();
                boxChart7popup = undefined;
            }
            boxChart7popup = Charts.create(args);
            break;
        case 'box8popup':
            if (boxChart8popup !== undefined) {
                boxChart8popup.destroy();
                boxChart8popup = undefined;
            }
            boxChart8popup = Charts.create(args);
            break;
        case 'annex1':
            if (annexChart1 !== undefined) {
                annexChart1.destroy();
            }
            annexChart1 = Charts.create(args);
            break;
        case 'annex2':
            if (annexChart2 !== undefined) {
                annexChart2.destroy();
            }
            annexChart2 = Charts.create(args);
            break;
        case 'annex3':
            if (annexChart3 !== undefined) {
                annexChart3.destroy();
            }
            annexChart3 = Charts.create(args);
            break;
        case 'annex4':
            if (annexChart4 !== undefined) {
                annexChart4.destroy();
            }
            annexChart4 = Charts.create(args);
            break;
        case 'annex5':
            if (annexChart5 !== undefined) {
                annexChart5.destroy();
            }
            annexChart5 = Charts.create(args);
            break;
        case 'annex6':
            if (annexChart6 !== undefined) {
                annexChart6.destroy();
            }
            annexChart6 = Charts.create(args);
            break;
        case 'annex7':
            if (annexChart7 !== undefined) {
                annexChart7.destroy();
            }
            annexChart7 = Charts.create(args);
            break;
        case 'annex8':
            if (annexChart8 !== undefined) {
                annexChart8.destroy();
            }
            annexChart8 = Charts.create(args);
            break;
    }
}


/**
 * Prepares the url used to get the chart data
 * @param module
 * @param route
 * @param id
 * @param fromYear
 * @param fromMonth
 * @param toYear
 * @param toMonth
 * @returns {string}
 */
function getChartUrl(module, route, id, fromYear, fromMonth, toYear, toMonth) {

    switch (parseInt(module)) {
        case ModuleType.AVD:
            return route + "?id=" + id + "&year=" + fromYear + "&month=" + fromMonth;
        default:
            return route + "?id=" + id + "&fromYear=" + fromYear + "&fromMonth=" + fromMonth + "&toYear=" + toYear + "&toMonth=" + toMonth;
    }

}

/**
 * Validates the data returned from the chart url to check if the datasets are empty, null, or Zero
 * @param box
 * @param data
 * @returns {boolean}
 */
function validateData(box, data){

    let validDatasets = [];
    let isValid;
    data['datasets'].forEach(function (dataset, index){
        isValid = true;

        let values = dataset['values'];

        if(checkEmptyValues(values)){
            isValid = false;
        }else if(checkAllValues(values, null)){
           isValid = false;
        }else if(checkAllValues(values, 0)){
            isValid = false;
        }else{
            isValid = true;
        }

        validDatasets[index] = isValid;
    });

    validDatasets.forEach(function (isDatasetValid) {
        if(isDatasetValid){
            isValid = true;
        }
    });

    return isValid;
}

/**
 * Checks if all values in an array is empty or not
 * @param arr
 * @returns {boolean}
 */
function checkEmptyValues(arr){
    return arr.length === 0;
}

/**
 * Checks if all values in an array is equal to the condition variable
 * @param arr
 * @param condition
 * @returns {*}
 */
function checkAllValues(arr, condition){
    return arr.every(element => element === condition);
}

/**
 * Shows the No Data message
 * @param box
 */
function showNoData(box){
    console.log("No Data Found for: #" + box);

    $('#' + box + "NoData").show();
    $('#' + box + "NoData").addClass("d-block");
    $('#' + box).addClass("d-block");
    $('#' + box + "NoData").removeClass("override");
    $('#' + "annex" + box[box.length -1]).addClass("override");
    $("#" + box + "ShowChart").hide();
    $('#loader' + box).hide();
    $("#chart" + box).hide();
}

/**
 * Shows the charts
 * @param box
 */
function showData(box){
    $('#' + box + "NoData").hide();
    $('#' + box + "NoData").addClass("override d-none");
    $('#' + box).removeClass("d-block");
    $('#' + "annex" + box[box.length -1]).removeClass("override");
    $("#" + box + "ShowChart").show();
    $('#loader' + box).hide();
    $("#chart" + box).show();
}
